import { getSymbolCaseStatement } from '@/utils/layers/styleFactory/symbols'
import { PartialLayerSpec } from '@/utils/layers/styleFactory/template'
import { ILayerValue } from '@lifk/types'
import { ExpressionSpecification } from 'mapbox-gl'

export default (
  layerValues: ILayerValue[],
  mapboxColorExpression: string | ExpressionSpecification,
  mapboxOpacityExpression?: ExpressionSpecification | number
): PartialLayerSpec[] => {
  // Optionally add variance to the layer by evaluating the modulo (%) operator against the
  // given modulator (dividend) and modulus (divisor)
  const mapboxSymbolExpression = getSymbolCaseStatement(
    layerValues.map(({ styleConfig, labelConfig }) => ({
      filter: labelConfig.filter,
      image: styleConfig.image,
      modulus: styleConfig.modulus,
      modulator: styleConfig.modulator
    }))
  )

  return [
    {
      id: 'fill',
      type: 'fill',
      paint: {
        'fill-color': mapboxColorExpression,
        'fill-outline-color': 'rgba(0, 0, 0, 0)',
        'fill-opacity': mapboxOpacityExpression
      }
    },
    {
      id: 'label',
      type: 'symbol',
      layout: {
        'icon-size': [
          'interpolate',
          ['exponential', 1.99],
          ['zoom'],
          11,
          0.25,
          13,
          1
        ],
        'icon-padding': 0,
        'icon-allow-overlap': true,
        'icon-ignore-placement': true,
        'icon-image': mapboxSymbolExpression,
        'symbol-avoid-edges': true
      },
      paint: {
        'icon-opacity': [
          'interpolate',
          ['linear'],
          ['zoom'],
          0,
          0,
          10.5,
          0,
          11.5,
          1
        ]
      }
    }
  ]
}
